__webpack_require__.p = "https://mf-reports.pages.dev/";